import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CasesPage = lazy(() => import('../pages/cases/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog-post/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const ComparacaoPage = lazy(() => import('../pages/comparacao/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/casos-de-sucesso',
    element: <CasesPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '/politica-de-privacidade',
    element: <PrivacyPage />,
  },
  {
    path: '/termos-de-uso',
    element: <TermsPage />,
  },
  {
    path: '/comparar-planos',
    element: <ComparacaoPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
